import { render, staticRenderFns } from "./PlacesList.vue?vue&type=template&id=362ea0ab&scoped=true&"
import script from "./PlacesList.vue?vue&type=script&lang=js&"
export * from "./PlacesList.vue?vue&type=script&lang=js&"
import style0 from "./PlacesList.vue?vue&type=style&index=0&id=362ea0ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ea0ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362ea0ab')) {
      api.createRecord('362ea0ab', component.options)
    } else {
      api.reload('362ea0ab', component.options)
    }
    module.hot.accept("./PlacesList.vue?vue&type=template&id=362ea0ab&scoped=true&", function () {
      api.rerender('362ea0ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/list/PlacesList.vue"
export default component.exports